<template>
  <div style="height:100%">
    <el-container direction="vertical" style="height:100%">
      <Header style="height:88px;"/>
      <el-main  class="main">
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Header from './Header.vue'
export default {
  components: {
    Header
  }
}
</script>
<style scoped>
.main {
  height: calc(100% - 88px);
}
</style>
